export const DEFAULT_MANAGE_RC_TAB = "users";

export const MANAGE_RC_TAB_IDS = [
  "overview",
  "users",
  "riskCenters",
  "riskAssessment",
  "settings",
];

export const MANAGE_SUB_RC_TAB_IDS = ["users", "settings"];

export function isValidManageRcTab(tab) {
  if (!tab) return false;
  return MANAGE_RC_TAB_IDS.includes(tab);
}

export function isValidManageSubRcTab(tab) {
  if (!tab) return false;
  return MANAGE_SUB_RC_TAB_IDS.includes(tab);
}

export function manageRiskCenterPath(id, tab = DEFAULT_MANAGE_RC_TAB) {
  const safeTab = isValidManageRcTab(tab) ? tab : DEFAULT_MANAGE_RC_TAB;
  return `/manage_risk_center/${id}/${safeTab}`;
}

export function manageSubRiskCenterPath(id, tab = DEFAULT_MANAGE_RC_TAB) {
  const safeTab = isValidManageSubRcTab(tab) ? tab : DEFAULT_MANAGE_RC_TAB;
  return `/manage_sub_risk_center/${id}/${safeTab}`;
}

export function parseManageRiskCenterLocation({ pathname }) {
  const parts = pathname.split("/").filter(Boolean);
  if (parts[0] !== "manage_risk_center" || !parts[1]) {
    return { id: null, tab: DEFAULT_MANAGE_RC_TAB };
  }
  const tab = parts[2] || DEFAULT_MANAGE_RC_TAB;
  return {
    id: parts[1],
    tab: isValidManageRcTab(tab) ? tab : DEFAULT_MANAGE_RC_TAB,
  };
}

export function parseManageSubRiskCenterLocation({ pathname }) {
  const parts = pathname.split("/").filter(Boolean);
  if (parts[0] !== "manage_sub_risk_center" || !parts[1]) {
    return { id: null, tab: DEFAULT_MANAGE_RC_TAB };
  }
  const tab = parts[2] || DEFAULT_MANAGE_RC_TAB;
  return {
    id: parts[1],
    tab: isValidManageSubRcTab(tab) ? tab : DEFAULT_MANAGE_RC_TAB,
  };
}
